import React, { memo } from 'react'

import NftList from './NftList'
import PageTitle from '../shared/pageTitle/PageTitle'

const Nfts = ({ nfts, onSelectNft, t, loadingNftBalance }) => {
  const pageTitle = t('shop.my-items')
  return (
    <>
      <PageTitle title={pageTitle} />
      <NftList
        nfts={nfts}
        onSelectNft={onSelectNft}
        loadingNftBalance={loadingNftBalance}
        t={t}
      />
    </>
  )
}

export default memo(Nfts)
